import { risapi, getAxiosConfig, handleApiError, getAPIFullUrl } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getPermissions = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/permissions', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const fetchPermission = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/permissions/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createPermission = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        const response = await risapi.post('/api/permissions', formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const updatePermission = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        formData.append('_method', 'put');
        const response = await risapi.post(`/api/permissions/${data.id}`, formData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const destroyPermission = async (permission, callback) => {
    try {
        const response = await risapi.delete(`/api/permissions/${permission.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ permission });
        }
    } catch (error) {
        callback(error);
    }
};
